// Base del servidor de medios: quita /api del final de la URL del backend
const MEDIA_BASE = (process.env.REACT_APP_API_URL || "http://localhost:4000/api")
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "");

/**
 * Construye la URL completa de una imagen almacenada en el backend.
 * Maneja rutas relativas ("uploads/company/x.jpg"),
 * URLs ya completas ("https://..."), base64 y valores nulos.
 */
export function getImageUrl(path) {
  if (!path) return null;
  if (path.startsWith("http") || path.startsWith("data:") || path.startsWith("blob:")) return path;
  // Asegura que haya exactamente un "/" entre la base y el path
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `${MEDIA_BASE}${clean}`;
}
